// support-context.tsx

import React, { createContext, useContext, useState, useEffect } from "react";
import { SupportCategory } from "./support-types";

interface SupportContextType {
  supportData: SupportCategory[];
  setSupportData: React.Dispatch<React.SetStateAction<SupportCategory[]>>;
  isLoading: boolean;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

const SupportContext = createContext<SupportContextType>({
  supportData: [],
  setSupportData: () => {},
  isLoading: true,
  setIsLoading: () => {},
});

export const useSupport = () => useContext(SupportContext);

export const SupportProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [supportData, setSupportData] = useState<SupportCategory[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  // 🔥 ADD THIS — auto-load support-data.json from /public
  useEffect(() => {
    async function loadSupport() {
      try {
        const res = await fetch("/support-data.json");

        if (!res.ok) {
          console.error("Could not load support-data.json", res.status);
          setIsLoading(false);
          return;
        }

        const json = await res.json();
        setSupportData(json);
      } catch (err) {
        console.error("Error loading support data", err);
      } finally {
        setIsLoading(false);
      }
    }

    loadSupport();
  }, []);

  return (
    <SupportContext.Provider
      value={{ supportData, setSupportData, isLoading, setIsLoading }}
    >
      {children}
    </SupportContext.Provider>
  );
};
